import React, { Component } from "react";
import InlineSVG from "svg-inline-react";
import "./index.css";
import MoveSVG from "../../Icons/MoveIcon";
import CircularProgressbar from "react-circular-progressbar";
import { SortableElement } from "react-sortable-hoc";
import TextField from "material-ui/TextField";

class ImgItem extends Component {
  render() {
    let { img, updateCaption, toggleCoverImage, deleteImage } = this.props;
    let { src, id, caption, isCover = false, fileId, progress = 0, uploaded = false } = img;
    let shouldShowProgress = !uploaded && progress < 100;
    return (
      <section id={id} className={`case-uploads-wrapper -form-wrapper`}>
        <div className="int-wrapper">
          <InlineSVG src={MoveSVG} className="-drag-drop-icon" />
          <div className={`-buttons-wrapper ${isCover ? "-cover-image" : ""}`}>
            <button className={`button -rounded -outline ${isCover ? "active" : ""}`} onClick={toggleCoverImage(id)}>
              {isCover ? "Cover Image" : "Set Cover Image"}
            </button>
            <button className="button -rounded -outline -delete" onClick={deleteImage(id, fileId)}>
              Delete
            </button>
          </div>
        </div>
        <div className="preview-box">
          {shouldShowProgress ? <CircularProgressbar percentage={Math.floor(progress)} /> : ""}
          {img.type === "video" ? (
            <video
              src={src}
              preload="metadata"
              className={`-uploaded-video ${shouldShowProgress ? "-uploading" : ""}`}
            />
          ) : (
            <img src={src} alt={id} className={`-uploaded-img  ${shouldShowProgress ? "-uploading" : ""}`} />
          )}
        </div>
        <TextField
          label="Add Caption"
          className="-img-caption"
          multiline
          rows="2"
          onChange={updateCaption(id)}
          value={caption}
        />
      </section>
    );
  }
}

export default SortableElement(ImgItem);



// WEBPACK FOOTER //
// ./src/scenes/NewCase/components/ImgItem/index.js